{
  "sdk-download-android": "Android 下載",
  "sdk-connect": "連接",
  "sdk-download-ios": "iOS 下載",
  "sdk-install": "安裝",
  "sdk-modal-instruct-1": "1. 開啟幣安 App",
  "sdk-modal-instruct-2": "2. 在首頁畫面上點擊 {{icon}}",
  "sdk-modal-title": "與幣安連接",
  "sdk-no-app": "還沒有幣安 App 嗎？"
}